<template>
  <div class="relative page-color">
    <div class="subheader absolute h-80 w-full">
      <div class="uppercase text-white w-full flex justify-center items-center h-full font-bold px-2 text-5xl">
        djuli microservices
      </div>
    </div>

    <div class="pt-64 z-10 flex flex-row flex-wrap px-20 relative basis-1/4">
      <div
        v-for="item in microserviceList"
        :key="item.id"
        class="inline-flex flex-col space-y-3 items-start justify-center w-72 h-60 pl-10 pr-6 pt-9 pb-3 bg-white card-items"
      >
        <img
          class="w-1/4 h-12 rounded-lg"
          src="../../assets/Images/udcicon.png"
        >
        <p class="text-xl font-semibold tracking-wider">
          {{ item.name }}
        </p>
        <p class="w-52 text-xs leading-tight text-gray-500">
          {{ item.description }}
        </p>
        <div class="w-full h-1/6 flex cursor-pointer">
          <a
            :href="item.url"
            class="inline-flex items-center justify-end w-full  text-gray-500 hover:underline"
            target="__blank"
          >
            Learn more
            <svg
              class="w-5 h-5 ml-2"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"
              />
              <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
            </svg>
          </a>
          <!-- <div class="flex items-center justify-end flex-1 h-full p-0.5">
                        <img class="rounded-lg" src="../../assets/Images/info.png" />
                    </div> -->
        </div>
      </div>
    </div>

    <div style="height: 66px" />
    <div
      class="inline-flex flex-col space-y-11 items-center justify-start px-80 pt-20 pb-16 bg-gray-200 w-full"
      style="height: 386px"
    >
      <p
        class="text-3xl font-semibold tracking-widest text-center text-gray-800"
        style="width: 773px"
      >
        Designed to make your work easier!
      </p>
      <p
        class="text-xl font-light tracking-widest text-center text-gray-800"
        style="width: 709px"
      >
        Djuli microservices are the tools that will help you work with
        your scientific data
      </p>
      <div class="inline-flex space-x-9 items-center justify-end w-1/5 h-1/4">
        <div class="flex space-x-0.5 items-center justify-end h-9">
          <img
            class="rounded-lg"
            src="../../assets/Images/company_icon.png"
          >
        </div>
      </div>
    </div>
    <div class="py-20 items-center">
      <div class="flex w-full justify-around px-16 flex-wrap items-center">
        <div>
          <figure>
            <img src="../../assets/Images/microaddons.png">
          </figure>
        </div>
        <div>
          <p
            class="text-3xl font-semibold tracking-widest text-gray-800"
            style="width: 534px"
          >
            Looking for another solution?
          </p>
          <p
            class="text-base font-light tracking-wider leading-normal text-gray-800"
            style="width: 430px"
          >
            Our team is working hard to provide you with all the
            nesessary tools that will help to improve your workflow
            efficiency. <br><br>If you have any thoughts on what
            we can add or if you have any requests for the tools
            that you need, please don’t hesitate to contact us!
          </p>
          <a
            class="button-item mt-16"
            href="https://www.zimmerpeacocktech.com/contact-support/"
          >
            <p class="text-base font-light tracking-wider text-center text-white">
              Contact us!
            </p>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            microserviceList: [
                {
                    id: 2,
                    url: 'https://doe-client-zu3hsmhdza-ez.a.run.app/',
                    name: 'Design of Experiment (DoE)',
                    icon: 'udcicon.png',
                    description:
                        'Simulate your experiment using desing of experiment (DoE) service',
                    info: [
                        {
                            name: 'Design of Experiment (DoE)',
                        },
                    ],
                },
            ],
        };
    },
    methods: {},
};
</script>

<style scoped>
.page-color {
    background-color: '#A3A3A3';
}

.subheader {
    font-family: 'Montserrat';
    letter-spacing: 0.38em;
    background: linear-gradient(257.33deg,
            #0b2838 45.78%,
            #025159 61.37%,
            #31c56f 84.64%);
}


.card-items {
    border: 1px solid whitesmoke;
}

.button-item {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 18px 34px;
    gap: 24px;

    width: 169px;
    height: 56px;

    /* Dark Green */

    background: #025159;
    border-radius: 7px;
}
</style>
